import type { Recipe } from '../../types'
import { image } from '../helpers'

export const painProtocole: Recipe = {
  slug: 'pain-protocole',
  title: 'Pain maison — levain ou levure',
  category: 'salé',
  description: 'Choisis ton ferment et tes horaires : la recette calcule la dose, les ingrédients et organise chaque étape.',
  image: image('pain-protocole'),
  tags: ['pain', 'levain', 'fermentation'],
  meta: [
    { label: 'Procédé', value: 'Avec ou sans passage au froid' },
    { label: 'Ferment', value: 'Levure sèche ou levain' },
    { label: 'Planning', value: 'Adapté à tes horaires' },
  ],
  special: 'pain',
  sections: [],
  steps: [],
}
